$(document).on('turbolinks:load', function() {
  $(document).on('click', ".connected_item_close_link", function (event) {
    $(this).parent().remove();
  });
});